interface WebGlTextureLimits {
  /**
   * Needed for selecting a compatible equirectangular panorama image size.
   */
  MAX_TEXTURE_SIZE: number

  /**
   * Not used for now, but we'll keep this as a reminder that we may want to
   * switch to cube map panorama textures later.
   */
  MAX_CUBE_MAP_TEXTURE_SIZE: number
}

function GetWebGlMaxTextureSize(): WebGlTextureLimits | null {
  const canvas = document.createElement('canvas')
  const gl = canvas.getContext('webgl')
  if (gl) {
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
    const maxCubeMapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE)
    console.log('MAX_TEXTURE_SIZE:', maxTextureSize)
    console.log('MAX_CUBE_MAP_TEXTURE_SIZE:', maxCubeMapSize)
    return {
      MAX_CUBE_MAP_TEXTURE_SIZE: maxCubeMapSize,
      MAX_TEXTURE_SIZE: maxTextureSize,
    }
  } else {
    console.error('WebGL not supported.')
    return null
  }
}

/**
 * Returns null if panorama rendering is not supported.
 *
 * If panorama rendering is supported, the returned value is the width integer
 * that should be sent to the image generator API.
 */
export function FindPanoramaImageWidthOrNull(): number | null {
  var limits = GetWebGlMaxTextureSize()
  if (new URLSearchParams(window.location.search).get('debug') === '1') {
    alert('WebGL texture limits: ' + JSON.stringify(limits))
  }

  if (limits == null) {
    return null // WebGL probably not supported.
  }

  if (limits.MAX_TEXTURE_SIZE == null) {
    return null // WebGL probably not supported.
  }

  if (limits.MAX_TEXTURE_SIZE < 4000) {
    return null // Not good enough for panorama.
  }

  if (limits.MAX_TEXTURE_SIZE < 8000) {
    // Scale to exactly half the unscaled width and height for maximum
    // downscaling quality.
    return 4000
  }

  // MAX_TEXTURE_SIZE >= 8000, instruct the image generator to avoid scaling and return the full
  // 8000 width resolution.
  return 0
}
